__turbopack_context__.v({
  "bubble": "application-process-eon-uk-module__T7S-xa__bubble",
});
